const processStepsData = [
    {
      step: "1",
      title: "Contact Us",
      description:
        "Get started by contacting our immigration specialists. We're available 24/7 to answer your questions and guide you.",
    },
    {
      step: "2",
      title: "Initial Consultation",
      description:
        "Schedule a free consultation to discuss your immigration goals, eligibility, and best path forward.",
    },
    {
      step: "3",
      title: "Form Preparation",
      description:
        "Our experts guide you through completing immigration forms accurately with step-by-step assistance.",
    },
    {
      step: "4",
      title: "Document Review",
      description:
        "We review all your documents and forms to ensure accuracy and compliance before submission.",
    },
    {
      step: "5",
      title: "Submission & Tracking",
      description:
        "We help submit your application to USCIS and provide real-time tracking of your case status.",
    },
  ];

  export default processStepsData;